import toast from 'react-hot-toast';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
/*import Button from '@mui/material/Button';*/
import Typography from '@mui/material/Typography';

export interface ApiResponse {
    errors: string[];
    result: number;
    type: ResponseType;
}

enum ResponseType {
    RegularCreatePost,
    UpdateScheduledPost,
    DraftPost,
    ScheduledPost
}

const getSuccessMessage = (type: ResponseType): string => {
    switch (type) {
        case ResponseType.RegularCreatePost:
            return "Your Post was published successfully.";
        case ResponseType.UpdateScheduledPost:
            return "Your scheduled post time has been updated successfully.";
        case ResponseType.DraftPost:
            return "Your post has been drafted.";
        case ResponseType.ScheduledPost:
            return "Your post has been scheduled successfully.";
        default:
            return "Operation successful!";
    }
};

export const handleApiResponse = (response: ApiResponse) => {
    if (response.errors && response.errors.length > 0) {
        response.errors.forEach(error => {
            toast.error(<ToastMessage message={error} icon={<Icon icon="ion:close-circle-outline" />} />);
        });
    } else if (response.result > 0) {
        const successMessage = getSuccessMessage(response.type);
        toast.success(<ToastMessage message={successMessage} icon={<Icon icon="material-symbols-light:check-circle-outline" />} />);
    } else {
        toast.error(<ToastMessage message='An error occurred. Please try again.' icon={<Icon icon="ion:alert-circle-outline" />} />);
    }
};

const ToastMessage = ({ message, icon }: { message: string, icon: any }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Icon icon={icon} width="24" height="24" style={{ marginRight: '8px' }} />
            <Typography>{message}</Typography>
        </Box>
    );
};

